import { useAuthState, useQuery } from '@based/sdk/react'
import listInitiativeFunction from 'functions/app/dashboard/profile/initiative/list/based.config'
import { DahsboardListInitiativeModel } from 'functions/app/dashboard/profile/initiative/list'
import { INITIATIVE_USER_ROLES } from '@schema/initiative'

const interestListQueryPayload = (userId: number) => ({
  userId,
  role: INITIATIVE_USER_ROLES.applicant,
  includeAllInitiativeUsers: false,
})

export const useInterestListInitiatives = (): {
  initiatives: DahsboardListInitiativeModel[]
} => {
  const { userId } = useAuthState()
  const numericUserId =
    userId === undefined || userId === null ? undefined : Number(userId)
  const enabled = numericUserId !== undefined && !Number.isNaN(numericUserId)

  const { data } = useQuery(
    enabled ? listInitiativeFunction.name : null,
    enabled
      ? interestListQueryPayload(numericUserId)
      : interestListQueryPayload(0),
  )

  return {
    initiatives: enabled
      ? ((data ?? []) as DahsboardListInitiativeModel[])
      : [],
  }
}
